import request from 'superagent';

class RecentExchangeStore {
  constructor() {
    this.addListener = this.addListener.bind(this);
    this.removeListener = this.removeListener.bind(this);
    this.getExchanges = this.getExchanges.bind(this);
    this.fireChanged = this.fireChanged.bind(this);
    this.onChangeFunctions = [];

    this.loaded = false;
    this.exchanges = [];
  }

  addListener(func) {
    this.onChangeFunctions.push(func);
  }

  removeListener(func) {
    for (let i = 0, l = this.onChangeFunctions.length; i < l; i += 1) {
      if (this.onChangeFunctions[i] === func) {
        this.onChangeFunctions.splice(i, 1);
        break;
      }
    }
  }

  fireChanged() {
    this.onChangeFunctions.forEach((func) => {
      func();
    });
  }

  getExchanges(callback) {
    request
      .get(`${process.env.REACT_APP_API_URL}/public/exchanges`)
      .accept('json')
      .end((error, response) => {
        if (error) return callback(error);
        if (response.body.status === 'fail' && response.body.code === 'NOT_FOUND') {
          this.loaded = true;
          this.fireChanged();

          return callback(false, []);
        }
        if (response.body.status !== 'success') return callback(response.body.message);

        this.exchanges = response.body.data.exchanges;
        this.loaded = true;
        this.fireChanged();

        return callback(false);
      });
  }
}

export default RecentExchangeStore;



// WEBPACK FOOTER //
// ./src/stores/RecentExchange.js